import { isDomainMode } from './domainMode';

/**
 * THE SHOP A PLATFORM ADDRESS NAMES — one reader for the cart bar and the
 * abandoned-cart tracker (2026-10-27 hotfix).
 *
 * Symptom, live: on `/<slug>` (no trailing slash — the link people share, and
 * where buyers land after tapping the shop's logo) a shopper tapped "+", the
 * badge said 1, and the cart drawer opened EMPTY ("Your cart is empty", no
 * checkout). Both readers used /^\/([^/]+)\//, which needs a slash AFTER the
 * slug, so on `/<slug>` the shop was null and `useCart('__none__')` opened a
 * cart that is always empty; the abandonment tracker missed those visits too.
 * The slug may now end the path: /^\/([^/]+)(?:\/|$)/. Two copies of the
 * regex drifted into the same bug, hence one helper.
 *
 * Reserved first segments (`/login`, `/profile`, …) still mean "no shop".
 *
 * Domain mode (a business's own domain) is deliberately UNCHANGED: there the
 * host decides the shop and a path is not a slug, so the slash-requiring form
 * stays — loosening it would turn a slug-less `/shop` or `/checkout` into a
 * shop called "shop".
 */
const RESERVED = new Set([
  'login', 'register', 'home', 'profile', 'appointments', 'booking',
  'customer-onboard', 'see-all-appointments', 'category', 'city',
  'add-appointment', 'appointment-details', 'pay', 'payments', 'terms',
  'privacy', 'legal', 'contact-us', 'booking-successful', 'orders',
  // 2026-10-27: now that `/<slug>` without a slash is read, a top-level platform page would read as a shop
  // ("stores", "checkout") and fire a cart heartbeat for a shop that does not exist. Every other top-level
  // path of App.js that is not a shop (the slug-less routes of a business's own domain included).
  'stores', 'explore', 'gallery', 'view-package', 'package-detail', 'checkout', 'order-placed',
  'shop', 'stays', 'stay', 'courses', 'p', 'receipt',
]);

export function shopSlugOfPath(pathname) {
  const path = String(pathname || '');
  const m = isDomainMode() ? path.match(/^\/([^/]+)\//) : path.match(/^\/([^/]+)(?:\/|$)/);
  if (!m) return null;
  return RESERVED.has(m[1]) ? null : m[1];
}
